module.exports = __webpack_public_path__ + "img/wish.08f99ee.svg?v=1764823240413";